import {createContext} from "react";

type PortalContainerContextType = {
  /** A ref to the object that should be used as the portal container for any child portals. */
  ref?: React.RefObject<HTMLElement>;
};

/**
 * Children wrapped in `PortalContainerContext.Provider` should use the passed
 * ref as the container for any child portals. */
export const PortalContainerContext = createContext<PortalContainerContextType>({});
